import React from 'react';
import { FadeIn } from './FadeIn';
import { Search, Wind, Salad, Puzzle, User, BookOpen } from 'lucide-react';
export function WhatsInsideSection() {
  const contents = [{
    icon: <Search className="w-6 h-6" data-id="element-192" />,
    title: 'Fase 1: Diagnóstico y Desactivación',
    desc: 'Identifica tu perfil (burnout, niebla mental o agotamiento) y aprende las herramientas de emergencia para los días 1 al 7.'
  }, {
    icon: <Wind className="w-6 h-6" data-id="element-193" />,
    title: 'El suspiro fisiológico de Stanford',
    desc: 'La técnica de 5 minutos que supera a la meditación para calmar la ansiedad de forma inmediata.'
  }, {
    icon: <Salad className="w-6 h-6" data-id="element-194" />,
    title: 'Fase 2: Nutrir el Cuerpo que Piensa',
    desc: 'Microbiota, movimiento, sueño y nutrición como medicina para tu cerebro (días 8 al 14).'
  }, {
    icon: <Puzzle className="w-6 h-6" data-id="element-195" />,
    title: 'Fase 3: Reprogramar la Mente',
    desc: 'TCC simplificada, defusión cognitiva y vínculos que sanan para los días 15 al 21.'
  }, {
    icon: <User className="w-6 h-6" data-id="element-196" />,
    title: 'Capítulo especial: Burnout maternal',
    desc: 'Para mujeres latinas que cargan con todo y no tienen permiso de estar agotadas.'
  }, {
    icon: <BookOpen className="w-6 h-6" data-id="element-197" />,
    title: 'Referencias científicas completas',
    desc: 'Cada afirmación respaldada por estudios reales — las citas están incluidas al final de la guía.'
  }];
  return <section className="py-20 bg-brand-cream" data-id="element-198">
      <div className="max-w-6xl mx-auto px-6" data-id="element-199">
        <FadeIn data-id="element-200">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-forest text-center mb-12" data-id="element-201">
            ¿Qué encontrarás en esta guía?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-202">
          {contents.map((item, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-203">
              <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 h-full border border-transparent hover:border-brand-sage hover:border-opacity-30" data-id="element-204">
                <div className="w-12 h-12 bg-brand-light-sage text-brand-forest rounded-xl flex items-center justify-center mb-6" data-id="element-205">
                  {item.icon}
                </div>
                <h3 className="font-serif font-bold text-xl text-brand-charcoal mb-3" data-id="element-206">
                  {item.title}
                </h3>
                <p className="text-brand-gray leading-relaxed" data-id="element-207">{item.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}